import {
  CalendarCheck,
  ClipboardCheck,
  Clock,
  FastForward,
  Lightbulb,
  NotebookPen,
  Users,
} from 'lucide-react';
import type { ChatQuickActionIcon } from '@/lib/chatPageOffer.ts';

/**
 * The picture on a quick action.
 *
 * Pages name the kind of thing they are offering; which drawing that is, is
 * decided once here — so two pages offering the same kind of help cannot end up
 * showing two different pictures of it.
 */
export function chatQuickActionIcon(icon: ChatQuickActionIcon) {
  switch (icon) {
    case 'tips':
      return <Lightbulb aria-hidden='true' />;
    case 'roleplay':
      return <FastForward aria-hidden='true' />;
    case 'check':
      return <ClipboardCheck aria-hidden='true' />;
    case 'week':
      return <CalendarCheck aria-hidden='true' />;
    case 'prepare':
      return <NotebookPen aria-hidden='true' />;
    case 'recap':
      return <Clock aria-hidden='true' />;
    case 'people':
      return <Users aria-hidden='true' />;
  }
}
